module.exports = __webpack_public_path__ + "media/images/bg-3-b5036acff4ba6506b547ec8bd986efcd.jpg";